import React from 'react'
import '../guia-de-estilos.css'

const GamaCromatica = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='py-3'>
            <h2 className='short-title font-semibold text-am-blue mt-4'>Gama cromática principal</h2>
            <p className='sub-title text-am-blue'>Se utiliza como primera opción para todos los productos corporativos digitales.</p>
          </div>
        <div className='container-lg p-0'>  
          <div className='row justify-content-center justify-content-md-start column-gap-3 row-gap-3'>
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-am-blue text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>AZUL AM</p>
              <p className='pt-5'>RGB 0/41/94<br/>#00295E</p>
              <p>.bg-am-blue</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-mexican-pink text-premium-blue text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>ROSA MEXICANO</p>
              <p className='pt-5'>RGB 250/0/115<br/>#FA0073</p>
              <p>.bg-mexican-pink</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-premium-blue text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>AZUL PREMIUM</p>
              <p className='pt-5'>RGB 2/12/65<br/>#020C41</p>
              <p>.bg-premium-blue</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-consistency-blue text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>AZUL CONSISTENCIA</p>
              <p className='pt-5'>RGB 3/13/117 <br/>#030D75</p>
              <p>.bg-consistency-blue</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-contemporary-blue text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>AZUL CONTEMPORÁNEO</p>
              <p className='pt-5'>RGB 0/0/227 <br/>#0000E3</p>
              <p>.bg-contemporary-blue</p>
            </div>
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-innovation-blue text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>AZUL INNOVACIÓN </p>
              <p className='pt-5'>RGB 3/92/247<br/>#035CF7</p>
              <p>.bg-innovation-blue</p>
            </div>          
          </div>
        </div>
        <div className='container-lg p-0 py-3'>
          <div className='row justify-content-center justify-content-md-start column-gap-3 row-gap-3'>
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-pure-white text-am-blue border text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>BLANCO PURO</p>
              <p className='pt-5'>RGB 255/255/255<br/>#FFFFFF</p>
              <p>.bg-innovation-blue</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-warm-white text-am-blue text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>BLANCO CÁLIDO</p>
              <p className='pt-5'>RGB 242/242/240<br/>#F2F2F0</p>
              <p>.bg-warm-white</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-premium-gray text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>GRIS PREMIUM</p>
              <p className='pt-5'>RGB 76/61/59<br/>#493D3A</p>
              <p>.bg-premium-gray</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-warm-gray text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>GRIS CÁLIDO</p>
              <p className='pt-5'>RGB 141/128/122<br/>#8D807A</p>
              <p>.bg-warm-gray</p>
            </div> 
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-soft-gray text-am-blue text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>GRIS SUAVE</p>
              <p className='pt-5'>RGB 220/204/201<br/>#DCCCC9</p>
              <p>.bg-soft-gray</p>
            </div>
            <div className='col-6 col-md-3 col-lg mx-2 card-lg bg-turquoise-innovation text-warm-white text-center fs-12 font-semibold'>
              <p className='mt-2 p-2'>TURQUESA INNOVACIÓN </p>
              <p className='pt-5'>RGB 220/204/201<br/>#07E7CC</p>
              <p>.bg-turquoise-innovation</p>
            </div>          
          </div>  
        </div>
      </div>
    </div>
  )
}

export default GamaCromatica